import React from 'react';
import { Progress } from 'tea-component';
import "./index.scss"
const TableProgress = (porps: any) => {
    let { cvm } = porps
    return (
        <Progress
            className="dbi-tabdetails-progress"
            type="circle"
            percent={cvm}
            strokeWidth={8}
            strokeColor="#376AE7"
          />
    );
};

export default TableProgress;